<template>
  <div class="markdown my-2" v-if="item">
    <div v-if="itemType === 'text'">
      <vue-markdown
        :source="item.value"
        :anchorAttributes="{
          target: '_blank',
          rel: 'nofollow',
        }"
      />
    </div>
    <div v-if="itemType === 'youtube'">
      <youtube :url="item.value" />
    </div>
    <div v-if="itemType === 'survey' && item.survey_id">
      <survey-preview :survey-id="item.survey_id" />
    </div>
    <div v-if="itemType === 'image' && item.image_id">
      <single-image :image-id="item.image_id" />
    </div>
  </div>
</template>

<script>
import { NewsEntryItem } from "@/modules/news/viewmodels/NewsEntryItem";

import VueMarkdown from "vue-markdown";

const Youtube = require("@/modules/news/components/Youtube.vue").default;
const SurveyPreview = require("@/modules/surveys/components/SurveyPreview.vue")
  .default;
const SingleImage = require("@/modules/images/components/SingleImage.vue")
  .default;

export default {
  name: "NewsEntryItem",
  data() {
    return {};
  },
  props: {
    item: {
      type: NewsEntryItem,
      required: true
    }
  },
  components: {
    VueMarkdown,
    Youtube,
    SurveyPreview,
    SingleImage
  },
  methods: {},
  computed: {
    itemType() {
      return this.item.type;
    }
  },
  created() {}
};
</script>